export default "__VITE_ASSET__4731716c__"